import { datadogRum } from '@datadog/browser-rum';
import { getCookie } from 'cookies-next';
import { useEffect, useState } from 'react';

import type { UserInfo } from '@/lib/utils/businessLogics/loginValidation';
import { env } from '@/lib/utils/env';
import { parseQueryStringToObject } from '@/lib/utils/parse';
function getMode() {
  switch (env.NEXT_PUBLIC_ENV) {
    case 'DEVELOPMENT':
      return 'local';
    case 'STAGING':
      return 'test';
    case 'PRODUCTION':
      return 'prod';
  }
}

const isBot =
  typeof navigator !== 'undefined' &&
  /bot|crawl|spider|googlebot|bingbot|yandex|baidu/i.test(navigator.userAgent);

function useInitDatadog() {
  useEffect(() => {
    if (isBot) {
      return;
    }

    const appId = env.NEXT_PUBLIC_DATADOG_APPLICATION_ID;
    const clientToken = env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN;

    if (!appId || !clientToken) {
      return;
    }

    try {
      datadogRum.init({
        applicationId: appId,
        clientToken,
        site: 'datadoghq.com',
        service: 'hanghae-frontend',
        version: '1.0.0',
        env: getMode(),
        sessionSampleRate: env.NEXT_PUBLIC_DATADOG_SESSION_RATE,
        sessionReplaySampleRate: Math.min(
          env.NEXT_PUBLIC_DATADOG_SESSION_REPLAY_RATE,
          10,
        ),
        defaultPrivacyLevel: 'mask-user-input',
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        beforeSend: (event) => {
          if (event.type === 'error') {
            datadogRum.startSessionReplayRecording();
          }
          return true;
        },
      });
    } catch (error) {
      console.error('Datadog 초기화 실패:', error);
    }
  }, []);
}

function useInitDatadogUser() {
  const [userInfo, setUserInfo] = useState<UserInfo | null>(null);

  useEffect(() => {
    const userInfoCookie = getCookie('userinfo');
    if (userInfoCookie) {
      setUserInfo(
        parseQueryStringToObject<UserInfo>(decodeURIComponent(userInfoCookie)),
      );
    }
  }, []);

  useEffect(() => {
    if (userInfo) {
      datadogRum.setUser({
        name: userInfo.name,
        email: userInfo.email,
        phone: userInfo.phone,
      });
    }
  }, [userInfo]);
}

export function useSetDataDog() {
  useInitDatadog();
  useInitDatadogUser();
}
